import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface StatementDraftResponse {
  data?: {
    id: string;
    title: string | null;
    summary: string | null;
    problem: string | null;
    solution: string | null;
    impact: string | null;
    budget: string | null;
    timing: string | null;
    attachment_url: string | null;
  };
}

/** Fetch a single draft's editable fields to prefill the form. */
export const useGetStatementDraft = (id: string | undefined) =>
  useQuery({
    queryKey: ["get", "/statements/drafts/{id}", id],
    enabled: !!id,
    queryFn: async () => {
      const { data, error } = await (
        fetchClient as unknown as {
          GET: (
            path: "/statements/drafts/{id}",
            init: { params: { path: { id: string } } },
          ) => Promise<{ data?: StatementDraftResponse; error?: unknown }>;
        }
      ).GET("/statements/drafts/{id}", {
        params: { path: { id: id ?? "" } },
      });
      if (error) throw error;
      return data;
    },
  });
